module.exports = __webpack_public_path__ + "static/media/Lars_UpperCladding_1.e2a3e009.jpg";